
export class ResponseError {

  constructor(errors) {
    this.errors = errors;
  }

  getErrors () {
    return this.errors;
  }

}



// WEBPACK FOOTER //
// ./src/network/response/response-error.js